<div class="reschedule-dialog">
    <div class="dialog-header">
        <h2 class="dialog-title">
            <i class="fa-solid fa-calendar-alt me-2"></i>
            Reprogramare
        </h2>
        <button type="button" class="btn-close-dialog" (click)="closeDialog()">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="dialog-content">
        <!-- Info despre programarea curentă -->
        <div class="current-appointment-info">
            <div class="info-header">
                <i class="fa-solid fa-info-circle me-2"></i>
                Programare curentă
            </div>
            <div class="info-body">
                <div class="row">
                    <div class="col-4">
                        <small class="text-muted">Data:</small>
                        <div class="fw-bold">{{ cerereData?.programare?.date | date:'dd.MM.yyyy' }}</div>
                    </div>
                    <div class="col-4">
                        <small class="text-muted">Ora:</small>
                        <div class="fw-bold">{{ cerereData?.programare?.time_from }}</div>
                    </div>
                    <div class="col-4">
                        <small class="text-muted">Locație:</small>
                        <div class="fw-bold">{{ cerereData?.programare?.denumire_locatie }}</div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Calendar și Sloturi -->
        <div class="selection-section">
            <div class="section-header">
                <i class="fa-solid fa-clock me-2"></i>
                Selectați noua dată și oră
            </div>
            <div class="section-body">
                <div class="row">
                    <!-- Calendar inline -->
                    <div class="col-md-6 mb-3">
                        <div class="calendar-wrapper">
                            <mat-calendar
                                #calendar
                                [selected]="selectedDate"
                                [minDate]="minDate"
                                [maxDate]="maxDate"
                                [dateFilter]="dateFilter"
                                (selectedChange)="onDateSelected($event)">
                            </mat-calendar>
                        </div>
                    </div>

                    <!-- Available Slots -->
                    <div class="col-md-6 mb-3">
                        <div class="slots-container" *ngIf="selectedDate">
                            <h5 class="slots-title">
                                <i class="fa-solid fa-list me-2"></i>
                                Sloturi pentru {{ selectedDate | date:'dd.MM.yyyy' }}
                            </h5>

                            <div *ngIf="loadingSlots" class="loading-slots">
                                <mat-spinner diameter="30"></mat-spinner>
                                <small class="text-muted">Se încarcă sloturile...</small>
                            </div>

                            <div *ngIf="!loadingSlots && availableSlots.length === 0" class="no-slots">
                                <i class="fa-solid fa-calendar-xmark"></i>
                                <p>Nu există sloturi disponibile pentru această dată.</p>
                            </div>

                            <div class="slots-grid" *ngIf="!loadingSlots && availableSlots.length > 0">
                                <button type="button"
                                    *ngFor="let slot of availableSlots"
                                    class="slot-btn"
                                    [class.selected]="selectedSlot === slot.time && !slot.isCurrentSlot"
                                    [class.current]="slot.isCurrentSlot"
                                    [class.reserving]="reservingSlot && selectedSlot === slot.time"
                                    [disabled]="slot.isCurrentSlot || reservingSlot"
                                    (click)="onSlotSelect(slot)">
                                    <span class="slot-time">{{ slot.time }}</span>
                                    <span class="slot-badge" *ngIf="slot.isCurrentSlot">curent</span>
                                    <mat-spinner diameter="16" *ngIf="reservingSlot && selectedSlot === slot.time" class="slot-spinner"></mat-spinner>
                                </button>
                            </div>
                        </div>

                        <div *ngIf="!selectedDate" class="select-date-prompt">
                            <i class="fa-solid fa-hand-pointer"></i>
                            <p>Selectați o dată din calendar pentru a vedea sloturile disponibile.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Preview Selecție -->
    <div class="selection-preview" *ngIf="selectedSlot && tempAppointmentId">
        <div class="preview-content">
            <div class="preview-icon">
                <i class="fa-solid fa-arrow-right-arrow-left"></i>
            </div>
            <div class="preview-details">
                <div class="preview-row">
                    <div class="preview-item old">
                        <span class="preview-label">De la:</span>
                        <span class="preview-value">{{ cerereData?.programare?.date | date:'dd.MM.yyyy' }} - {{ cerereData?.programare?.time_from }}</span>
                    </div>
                    <div class="preview-arrow">
                        <i class="fa-solid fa-arrow-right"></i>
                    </div>
                    <div class="preview-item new">
                        <span class="preview-label">La:</span>
                        <span class="preview-value">{{ selectedDate | date:'dd.MM.yyyy' }} - {{ selectedSlot }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="dialog-footer">
        <button type="button" class="btn btn-outline-secondary" (click)="closeDialog()">
            {{ helper.dialogConfig.buttonLabels.close }}
        </button>
        <button type="button" class="btn btn-primary" (click)="submitForm()"
            [disabled]="form.invalid || !selectedSlot || !tempAppointmentId || isLoading || reservingSlot">
            <i class="fa-solid fa-check me-2" *ngIf="!isLoading"></i>
            <i class="fa-solid fa-spinner fa-spin me-2" *ngIf="isLoading"></i>
            Reprogramează
        </button>
    </div>
</div>

<!-- Loading Overlay -->
<div class="loading-overlay" *ngIf="isLoading">
    <div class="spinner-container">
        <mat-spinner diameter="50"></mat-spinner>
        <p>{{ helper.dialogConfig.generalMessages.pleaseWait }}</p>
    </div>
</div>
